// extracted by mini-css-extract-plugin
module.exports = {"establishments":"StationsUsersGroups_establishments__11jiS","header":"StationsUsersGroups_header__3f3tP","tableHeader":"StationsUsersGroups_tableHeader__Kypz9"};